import { apiRequest  } from './base';


export const createSite = async (name, siteKey, siteSecret) => {
  return apiRequest('/sites/', 'POST', null, {
    name: name,
    site_key: siteKey, 
    site_secret: siteSecret
  });
};

export const updateSite = async (siteId, name=null, siteKey=null, siteSecret=null, disabled=null) => {
  return apiRequest(`/sites/${siteId}`, 'PUT', null, {
    name: name,
    site_key: siteKey,
    site_secret: siteSecret,
    is_disabled: disabled
  });
};

export const deleteSite = async (siteId) => {
  return apiRequest(`/sites/${siteId}`, 'DELETE');
};

export const fetchUserSites = async (filterInactive = true) => {
  return apiRequest(`/user-sites`, 'GET', null, {filter_inactive: filterInactive});
};

export const createSiteUser = async (siteId, email, role) => {
  return apiRequest('/site-users/', 'POST', null, {
    site_id: siteId,
    email: email,
    role: role
  });
};

export const fetchSiteUsers = async (siteId) => {
  return apiRequest('/site-users/', 'GET', null, {
    site_id: siteId
  });
};

export const updateSiteUser = async (userId, siteId, role) => {
  return apiRequest(`/site-users/${siteId}/${userId}`, 'PUT', null, {
    role: role
  });
};

export const deleteSiteUser = async (userId, siteId) => {
  return apiRequest(`/site-users/${siteId}/${userId}`, 'DELETE');
};

export const createSiteUserPermission = async (userId, siteId, permission) => {
  return apiRequest('/site-user-permissions/', 'POST', null, {
    user_id: userId,
    site_id: siteId,
    permission: permission
  });
};

export const fetchSiteUserPermissions = async (siteId, userId=null) => {
  if (userId) {
    return apiRequest(`/site-user-permissions/${siteId}/${userId}`);
  }
  return apiRequest(`/site-user-permissions/${siteId}`);
};

export const deleteSiteUserPermission = async (userId, siteId, permission) => {
  return apiRequest(`/site-user-permissions/${siteId}/${userId}/${permission}`, 'DELETE');
};


export const canCreateSiteApi = async () => {
  return apiRequest(`/can_create_site`, 'GET', null);
};
